import { useSelector } from 'react-redux';
import React from 'react';
import { getIsLocationPlatformDesktopSelector } from '../../Location/locationSelectors';
import UserStatusCongratulationsButtons from './UserStatusCongratulationsButtons';
import UserStatusCongratulationsBenefits from './UserStatusCongratulationsBenefits/UserStatusCongratulationsBenefits';
import UserStatusCongratulationsHeader from './UserStatusCongratulationsHeader';
import {
    UserStatusCongratulationsDesktopInfoStyled,
    UserStatusCongratulationsDesktopStyled,
    UserStatusCongratulationsMobileStyled,
} from './styled/UserStatusCongratulationsStyled';
import UserStatusCongratulationsIcon from './UserStatusCongratulationsIcon';

function UserStatusCongratulations() {
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);

    return isDesktop
        ? <UserStatusCongratulationsDesktopStyled>
            <UserStatusCongratulationsDesktopInfoStyled>
                <UserStatusCongratulationsIcon/>
                <div className={'d-flex flex-column align-items-center'}>
                    <UserStatusCongratulationsHeader/>
                    <UserStatusCongratulationsButtons/>
                </div>
            </UserStatusCongratulationsDesktopInfoStyled>

            <UserStatusCongratulationsBenefits/>
        </UserStatusCongratulationsDesktopStyled>

        : <UserStatusCongratulationsMobileStyled>
            <UserStatusCongratulationsIcon/>
            <UserStatusCongratulationsHeader/>
            <UserStatusCongratulationsBenefits className={'mt-4'}/>
            <UserStatusCongratulationsButtons myStatusButtonVariant={'tertiary'}/>
        </UserStatusCongratulationsMobileStyled>;
}

export default UserStatusCongratulations;
